import { Sprite } from 'pixi.js'
import { delay } from '@/scripts/helpers/animation'

// Morse map (letters and digits)
const MORSE: Record<string, string> = {
  A: '.-',
  B: '-...',
  C: '-.-.',
  D: '-..',
  E: '.',
  F: '..-.',
  G: '--.',
  H: '....',
  I: '..',
  J: '.---',
  K: '-.-',
  L: '.-..',
  M: '--',
  N: '-.',
  O: '---',
  P: '.--.',
  Q: '--.-',
  R: '.-.',
  S: '...',
  T: '-',
  U: '..-',
  V: '...-',
  W: '.--',
  X: '-..-',
  Y: '-.--',
  Z: '--..',
  0: '-----',
  1: '.----',
  2: '..---',
  3: '...--',
  4: '....-',
  5: '.....',
  6: '-....',
  7: '--...',
  8: '---..',
  9: '----.',
}

/** Strip diacritics, uppercase, keep letters/digits/space/basic punctuation. */
function normalizeForMorse(input: string): string {
  const stripped = (input.normalize ? input.normalize('NFD') : input).replace(/[\u0300-\u036f]+/g, '')
  return stripped
    .toUpperCase()
    .replace(/[^A-Z0-9 .,!?:;'"()\-/&_=@]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
}

export async function playMorseLoop(
  sprite: Sprite,
  messages: string[],
  timings: {
    dot: number
    dash: number
    symbolGap: number
    letterGap: number
    wordGap: number
    messageGap: number
  },
) {
  const cleanMessages = messages.map(normalizeForMorse).filter(Boolean)
  while (true) {
    for (let i = 0; i < cleanMessages.length; i++) {
      await playSingleMorseMessage(sprite, cleanMessages[i], timings)
      await delay(timings.messageGap)
    }
  }
}

async function playSingleMorseMessage(
  sprite: Sprite,
  text: string,
  timings: { dot: number; dash: number; symbolGap: number; letterGap: number; wordGap: number },
) {
  const words = text.split(' ')
  for (let w = 0; w < words.length; w++) {
    const word = words[w]

    for (let i = 0; i < word.length; i++) {
      const ch = word[i]
      const code = MORSE[ch]
      if (!code) continue

      for (let sIdx = 0; sIdx < code.length; sIdx++) {
        const onTime = code[sIdx] === '.' ? timings.dot : timings.dash
        sprite.visible = true
        await delay(onTime)
        sprite.visible = false
        if (sIdx < code.length - 1) await delay(timings.symbolGap)
      }
      if (i < word.length - 1) await delay(timings.letterGap)
    }
    if (w < words.length - 1) await delay(timings.wordGap)
  }
}
